import { ErrorModal, HelmetDexteel } from "@dexteel/mesf-core";
import Grid from "@mui/material/Grid";
import Paper from "@mui/material/Paper";
import { get } from "lodash-es";
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { getCatalogPourbackReasons } from "../../../repositories/CatalogPourbackReasonRepository";
import { TablePourbackReason } from "../components/TablePourback";
import { useCatalogPourbackContext } from "../context/CatalogPourbackContext";
type Props = {};

export const CatalogPourbackPage = (props: Props) => {
  const { actions } = useCatalogPourbackContext();
  const { pourbackReasonId } = useParams();

  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState("");

  const getCatalogPourbackReasonsFromAPI = async () => {
    setIsLoading(true);
    const resp = await getCatalogPourbackReasons();
    if (resp.ok) {
      const pourbackReasons = get(resp, "data.tables[0].rows", []);
      actions.setPourbackReasons(pourbackReasons);
    } else {
      setError(resp.message);
    }
    setIsLoading(false);
  };

  useEffect(() => {
    getCatalogPourbackReasonsFromAPI();
  }, []);

  return (
    <>
      <HelmetDexteel title={"Pourback Reasons"} />
      <Grid container justifyContent="center" alignItems="center">
        <Grid item md={12} xs={12} style={{ margin: 0 }}>
          <Paper
            elevation={1}
            style={{
              width: "100%",
              padding: "10px 0 20px",
              borderRadius: "0.75rem",
              height: "auto",
            }}
          >
            <TablePourbackReason
              pourbackReasonId={pourbackReasonId}
              isLoading={isLoading}
              getCatalogPourbackReasonsFromAPI={
                getCatalogPourbackReasonsFromAPI
              }
            />
          </Paper>
        </Grid>
      </Grid>
      <ErrorModal error={error} onHide={() => setError("")} />
    </>
  );
};
